var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 22",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.326.333h.35a6.887 6.887 0 0 1 4.986 2.35c2.356 2.677 2.208 6.847-.236 9.58l-.229.244-8.229 8.42a2.465 2.465 0 0 1-3.365.147l-.157-.148-8.44-8.635A7.07 7.07 0 0 1 .001 7.164a7.059 7.059 0 0 1 2.27-5.013c2.66-2.45 6.843-2.294 9.551.246l.235.23.148.15.361-.366A6.891 6.891 0 0 1 16.652.383l.331-.033.343-.017Zm.258 3.232a3.548 3.548 0 0 0-2.462.911l-.182.174-1.547 1.582a1.667 1.667 0 0 1-2.238.124l-.135-.124-1.335-1.366c-1.463-1.497-3.76-1.648-5.164-.355a3.853 3.853 0 0 0-1.23 2.736 3.88 3.88 0 0 0 .914 2.615l.173.19 7.828 8.007 7.618-7.791c1.369-1.4 1.62-3.591.644-5.083l-.14-.199-.156-.19a3.576 3.576 0 0 0-2.588-1.23Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));
export default SvgHeart;